
















































import { BButton, BFormGroup, BFormInput, BFormTextarea, VBTooltip } from "bootstrap-vue";
import VariablePicker from "@/components/variablePicker.vue";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import { computed, defineComponent } from "@vue/composition-api";
import { ValidationProvider } from "vee-validate";

export default defineComponent({
    components: {
        BFormTextarea,
        BFormGroup,
        DescriptionInputCounter,
        BButton,
        BFormInput,
        VariablePicker,
        ValidationProvider,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        value: {
            required: true,
            type: String,
        },
    },
    setup(props, { emit }) {
        const headerText = computed<string>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        return {
            headerText,
        };
    },
});
